import React, { useState } from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProcessSection } from '../components/ProcessSection';
import { ServicesGrid } from '../components/ServicesGrid';
import { TechStack } from '../components/TechStack';
import { ContactForm } from '../components/ContactForm';
import { Zap, Sun, Moon, Mail } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

const CONTACT_EMAIL = 'contact.automateops@gmail.com';

export const LandingPage = () => {
  const { theme, toggleTheme } = useTheme();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  
  const scrollToSection = (sectionId) => {
    document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
    setIsMobileMenuOpen(false);
  };
  
  const openGmail = () => {
    window.open(`https://mail.google.com/mail/?view=cm&fs=1&to=${CONTACT_EMAIL}`, '_blank');
    setIsMobileMenuOpen(false);
  };
  
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };
  
  return (
    <div className="landing-page">
      <header className="dark-header">
        <div className="header-logo">
          <Zap className="logo-icon" size={28} strokeWidth={2.5} />
          <span className="logo-text">Automate Ops</span>
        </div>
        
        <nav className={`dark-nav ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
          <a 
            href="#services" 
            className="dark-nav-link"
            onClick={(e) => { e.preventDefault(); scrollToSection('services'); }}
          >
            Services
          </a>
          <a 
            href="#process" 
            className="dark-nav-link"
            onClick={(e) => { e.preventDefault(); scrollToSection('process'); }}
          >
            Process
          </a>
          <a 
            href="#tech" 
            className="dark-nav-link"
            onClick={(e) => { e.preventDefault(); scrollToSection('tech'); }}
          >
            Tech Stack
          </a>
          
          <button 
            onClick={openGmail}
            className="contact-email-btn"
            title="Email us on Gmail"
          >
            <Mail size={20} />
            <span className="contact-btn-text">Contact Us</span>
          </button>
          
          <button 
            className="theme-toggle"
            onClick={toggleTheme}
            aria-label="Toggle theme"
          >
            {theme === 'dark' ? (
              <Sun size={20} />
            ) : (
              <Moon size={20} />
            )}
          </button>
          
          <a 
            href="#contact-section" 
            className="btn-primary btn-nav"
            onClick={(e) => {
              e.preventDefault();
              scrollToSection('contact-section');
            }}
          >
            Get Started
          </a>
        </nav>
        
        <div className="mobile-menu-toggle">
          <button 
            className={`hamburger-btn ${isMobileMenuOpen ? 'active' : ''}`}
            onClick={toggleMobileMenu}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </header>
      
      <main className="main-content">
        <HeroSection />
        <ProcessSection />
        <ServicesGrid />
        <TechStack />
        <ContactForm />
      </main>
      
      <footer className="dark-footer">
        <div className="footer-container">
          <div className="footer-brand">
            <div className="footer-logo-group">
              <Zap className="footer-logo-icon" size={24} strokeWidth={2.5} />
              <span className="footer-logo">Automate Ops</span>
            </div>
            <p className="footer-tagline">Enterprise AI Automation Solutions</p>
            <button onClick={openGmail} className="footer-email">
              {CONTACT_EMAIL}
            </button>
          </div>
          
          <div className="footer-links">
            <div className="footer-column">
              <h4 className="footer-heading">Services</h4>
              <a href="https://n8n.io" target="_blank" rel="noopener noreferrer" className="footer-link">CRM Automation</a>
              <a href="https://openai.com" target="_blank" rel="noopener noreferrer" className="footer-link">AI Chatbots</a>
              <a href="https://zapier.com" target="_blank" rel="noopener noreferrer" className="footer-link">API Integration</a>
              <a href="https://supabase.com" target="_blank" rel="noopener noreferrer" className="footer-link">Database Setup</a>
            </div>
            
            <div className="footer-column">
              <h4 className="footer-heading">Company</h4>
              <a href="https://about.google" target="_blank" rel="noopener noreferrer" className="footer-link">About Us</a>
              <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="footer-link">Case Studies</a>
              <a href="https://medium.com" target="_blank" rel="noopener noreferrer" className="footer-link">Blog</a>
              <button onClick={openGmail} className="footer-link">Contact</button>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p className="footer-copyright">© 2025 Automate Ops. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};
